import "../App.css"

export function AppNav() {
    return (
        <div id="appnav" className="AppNav">
        </div>
    );
}
